<template>
  <TrfSimpleModal titulo="Aviso" :isModalPersonalizado="true">
      <div 
        id="conteudo-modal-permissao-departamento"
        class="modal-list-content px-5 pb-1 custom-y-scrollbar"
        style="
          height: 100%;
          max-height: 60vh;
          max-width: 640px;
          width: 100%;
          overflow: auto;
        " 
      >
          <div class="content">
          <p class="mt-4">
            Identificamos que o usuário responsável vinculado a esta tarefa não possui as permissões 
            necessárias para acessar a(s) empresa(s) e/ou departamento listado(s) abaixo.
            Com isso, as tarefas relacionadas a essa(s) empresa(s) e/ou departamento não estarão visíveis na área de dashboard do usuário.
          </p>
          <p>
            Para resolver esta situação será preciso ajustar o cadastro do usuário responsável
            concedendo a permissão a esta(s) empresa(s) e/ou departamento.
          </p>
          <div v-if="permissoesEmpresas.length != 0">
            <p>
              <strong>Empresa(s) </strong><br>
              <ul>
                <li v-for="(item, index) in permissoesEmpresas" :key="index">{{ item }}</li>
              </ul>
            </p><p></p>
          </div>
          <div v-if="permissoesDepartamentos.length != 0">
            <p>
              <strong>Departamento</strong><br>
              <ul>
                <li v-for="(item, index) in permissoesDepartamentos" :key="index">{{ item }}</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </TrfSimpleModal>
</template>

<script>
import TrfSimpleModal from "./TrfSimpleModal.vue";

export default {
  name: "ModalDashboardPermissaoCadastro",
  components: {
    TrfSimpleModal,
  },
  props: {
    permissoesDepartamentos: {
      type: Array,
      required: true,
    },
    permissoesEmpresas: {
      type: Array,
      required: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
  